// ------------------------------------
// Import SCSS files
// ------------------------------------
import "../sass/catalog.scss";

// ------------------------------------
// Scripts
// ------------------------------------

import "./components/header";
import "./components/modals";
import "./components/catalog-filter";